/* 
 	* 指令下发组件 
 	* 描述：InsMG50CaliVehicles指令下发
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
     	<form class="form-horizontal">
     		<div class="form-group">
				<label class="col-sm-2 control-label">指令参数</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="vehicles" readonly="readonly"> 
			    </div>	
				<div class="col-sm-1 text-right">
				<span class="red dis_block  pt5px">*</span>
				</div>
			    <div class="col-sm-3">
					<select class="form-control" v-model="vehicles">
						<option value="">车型列表</option>
						<option value="0">默认</option>
						<option value="1">路虎</option>
						<option value="2">丰田</option>
						<option value="3">奔驰</option>
						<option value="4">宝马</option>
						<option value="5">福特</option>
						<option value="6">通用</option>
						<option value="7">本田</option>
						<option value="8">起亚</option>
						<option value="9">大众</option>
						<option value="10">现代</option>
						<option value="11">马自达</option>
						<option value="12">日产</option>
						<option value="14">吉普</option>
						<option value="15">长城（哈佛）</option>
						<option value="16">海马</option>
						<option value="255">关闭OBD功能</option>
					</select>
			    </div>
			    <label class="control-label"><span class=" weight_n orange_t">255表示关闭OBD</span></label>
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
			 <div class="form-group text-right" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
	    </form>
    </div>	
</template>
<script>
	export default {
		name: "InsMG50CaliVehicles",
		data() {
			return {
				vehicles:"",                //车系选择
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.vehicles = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				if(this.vehicles == ""){
					this.alertMsg = "请选择车型列表";
					return;
				}
				else{
					this.alertMsg = ''
				}
				let arr = ["SETPRM","0000F003",this.vehicles]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsMG50CaliVehicles.vue?4b7612df